module.exports = __webpack_public_path__ + "img/default.3bfcf523.png";